import React from "react";
import { MessageSquareText } from "lucide-react";

export default function ResultBox(props) {
  return (
    <div className="rounded-md border border-slate-200 bg-white p-5 shadow-sm">
      <div className="mb-4 flex items-center gap-3">
        <span className="grid h-10 w-10 shrink-0 place-items-center rounded-md bg-purple-50 text-purple-700">
          <MessageSquareText className="h-5 w-5" aria-hidden="true" />
        </span>
        <div>
          <p className="text-sm font-semibold uppercase text-purple-700">
            Result
          </p>
          <h3 className="text-xl font-extrabold text-gray-900">
            Transcribed response
          </h3>
        </div>
      </div>

      <div className="flex flex-wrap rounded-md bg-slate-50 p-4 text-sm leading-7 text-gray-900 ring-1 ring-slate-100">
        {props.result}
      </div>
    </div>
  );
}
